import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
declare var document: any;
import * as $ from "jquery";
import { SessionService } from '../../../shared/services/session.service';
@Component({
  selector: 'app-yr3-st-stava-chapter6',
  templateUrl: './yr3-st-stava-chapter6.component.html',
  styleUrls: ['./yr3-st-stava-chapter6.component.scss']
})

export class Yr3StStavaChapter6Component implements OnInit {

  public bloburl: string;
  private stage: any;
  public eventHandler: any;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<Yr3StStavaChapter6Component>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;

  }

  ngOnInit() {

    var bloburl = this.sessionService.bloburl;
    var userAgent = navigator.userAgent.toLowerCase();
    var android_dev = userAgent.indexOf("android") > -1;
    var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var stage = new createjs.Stage("yr3_canvas");
    this.stage = stage;
    if (!isIOS) {

      createjs.Touch.enable(stage);

    }
    createjs.MotionGuidePlugin.install();

    var yr3_canvas: any = document.getElementById('yr3_canvas');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 890;

    var yr3_bitmap = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/frame.png");
    yr3_bitmap.setTransform(0, 0, 0.992, 0.97);

    var yr3_option_container = new createjs.Container();

    var yr3_dashed_rect = new createjs.Shape();
    yr3_dashed_rect.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#ED8505").setStrokeDash([6, 6]).drawRoundRect(0, 0, 150, 78, 10);
    yr3_dashed_rect.setTransform(83, 180);

    var yr3_tagimage1 = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/tagimages/chapter6_tag.png");
    yr3_tagimage1.setTransform(42, 55);
    yr3_tagimage1.visible = true;

    var yr3_opt_text1 = new createjs.Text("Stava 1", "17px MyriadPro-Regular", "#000000");
    yr3_opt_text1.setTransform(138, 196);

    var yr3_opt_text2 = new createjs.Text("Stava 2", "17px MyriadPro-Regular", "#000000");
    yr3_opt_text2.setTransform(138, 229);

    yr3_option_container.addChild(yr3_dashed_rect, yr3_opt_text1, yr3_opt_text2);
    var yr3_opt_circle1: any = new createjs.Shape();
    yr3_opt_circle1.overColor = "#ED8505";
    yr3_opt_circle1.outColor = "#FFFFFF";
    yr3_opt_circle1.graphics.setStrokeStyle(2).beginFill(yr3_opt_circle1.overColor).beginStroke("#000000").drawCircle(0, 0, 11);
    yr3_opt_circle1.setTransform(115, 203);
    yr3_opt_circle1.cursor = 'pointer';
    yr3_opt_circle1.name = "Twobilder";
    yr3_opt_circle1.addEventListener("click", function () {
      yr3_ex_stava(bloburl, 0);
      document.getElementById("temp_textbox").style.display = "none";
      $("#temp_textbox").blur();
    });

    var yr3_opt_circle2: any = new createjs.Shape();
    yr3_opt_circle2.overColor = "#ED8505";
    yr3_opt_circle2.outColor = "#FFFFFF";
    yr3_opt_circle2.graphics.setStrokeStyle(2).beginFill(yr3_opt_circle2.outColor).beginStroke("#000000").drawCircle(0, 0, 11);
    yr3_opt_circle2.setTransform(115, 235);
    yr3_opt_circle2.cursor = 'pointer';
    yr3_opt_circle2.name = "Threebilder";
    yr3_opt_circle2.addEventListener("click", function () {
      yr3_ex_skriva(bloburl, 0);
      document.getElementById("temp_textbox").style.display = "none";
      $("#temp_textbox").blur();
    });
    var newexe1 = new Image();
    newexe1.crossOrigin = 'Anonymous';
    newexe1.src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/fortsatt.png';

    let yr3_fortsattimg = new createjs.Bitmap(newexe1);
    yr3_fortsattimg.setTransform(1550, 742);
    yr3_fortsattimg.visible = false;
    yr3_fortsattimg.cursor = 'pointer';

    yr3_fortsattimg.addEventListener('click', function () {
      yr3_fortsattimg.visible = false;
      yr3_ex_skriva(bloburl, 0);
    });

    var yr3_chapterimg = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/chapterimages/ch6_image.png");
    yr3_chapterimg.setTransform(1518, 80);

    var newexe = new Image();
    newexe.crossOrigin = 'Anonymous';
    newexe.src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/kontrollera.png';

    var newexe2 = new Image();
    newexe2.crossOrigin = 'Anonymous';
    newexe2.src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/newexercise.png';

    let yr3_next_button = new createjs.Bitmap(newexe2);
    yr3_next_button.setTransform(1550, 745);
    yr3_next_button.visible = false;
    yr3_next_button.cursor = 'pointer';

    var cheersound: any[string];
    cheersound = new Array(34);
    for (var i = 0; i < 34; i++) {
      cheersound[i] = new Audio();
      cheersound[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/cheerssound/audio' + i + '.mp3';
    }

    
    var exercise = 1;
    var yr3_ex_stava: any = function (bloburl, audiocount1) {
      yr3_next_button.addEventListener('click', function () {
        yr3_next_button.visible = false;
        audiocount1 = audiocount1 + 1;

        if (audiocount1 == 34) {
          yr3_ex_stava(bloburl, 0);
          shuffle(cheersound, cheersound);
        }
        else {
          yr3_ex_stava(bloburl, audiocount1);
        }
      });
      for (var s = 0; s < stage.children.length; s++) {
        if (stage.children[s].name == "removeimage" || stage.children[s].name == "removeimage1") {
          stage.removeChild(stage.children[s]);
          s = s - 1;
        }
      }

      yr3_fortsattimg.visible = false;


      yr3_opt_circle1.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle1.overColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();
      yr3_opt_circle2.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle2.outColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();

      var yr3_heading1 = new createjs.Text("Stava", "bold 60px Dk-mariken", "#FF0000");
      if (isIOS) {

        var yr3_heading1 = new createjs.Text("Stava", "60px Dk-mariken", "#FF0000");
        yr3_heading1.outline = 2;

        var yr3_heading1_ipad = new createjs.Text("Stava", "60px Dk-mariken", "#FF0000");
        yr3_heading1_ipad.textAlign = "center";
        yr3_heading1_ipad.name = "removeimage";
        yr3_heading1_ipad.setTransform(890, 80);
      }
      yr3_heading1.textAlign = "center";
      yr3_heading1.name = "removeimage";
      yr3_heading1.setTransform(890, 80);

      var yr3_chaptertextarray = ["Stjärna", "Skjuta", "Stjäla", "Skjul", "Blomstjälk", "Skjorta", "Skolskjuts", "Stjärt", "Stjälk", "Vedskjul",
        "Skjutsa", "Rockstjärna"];

      var yr3_soundsArr = [bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio1.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio2.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio3.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio4.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio5.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio6.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio7.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio8.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio9.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio10.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio11.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio12.mp3"
      ];

      shuffle(yr3_chaptertextarray, yr3_soundsArr);

      for (var i = 0; i < 12; i++) {
        for (var j = 0; j < yr3_chaptertextarray[i].length; j++) {
          var yaxis_box = 280;
          var Xpos = 360;
          if (i > 5) {
            Xpos = 1058;
            yaxis_box = -200;
          } else {
            Xpos = 360;
            yaxis_box = 280;
          }

          var yr3_linecontainer = new createjs.Container();

          let yr3_ansline = new createjs.Shape();
          yr3_ansline.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke('#01C1D6').drawRoundRect(0, 0, 40, 40, 0);
          yr3_ansline.setTransform(Xpos + (j * 40), yaxis_box + (i * 80));

          yr3_linecontainer.addChild(yr3_ansline);
          yr3_linecontainer.name = "removeimage";
          stage.addChild(yr3_linecontainer);
        }
      }

      var sounds = [];

      for (var t = 0; t < yr3_soundsArr.length; t++) {
        var sound1: any = new Audio();
        sound1.src = yr3_soundsArr[t];
        sound1.name = "removeimage";
        sound1.crossOrigin = "Anonymous";
        sounds.push(sound1);
      }

      var audiobutton_1 = new Image();
      audiobutton_1.crossOrigin = "Anonymous";
      audiobutton_1.name = "removeimage";
      audiobutton_1.src = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/play.png";

      var count = 0;
      for (var i = 0; i < 12; i++) {
        for (var j = 0; j < 1; j++) {
          var posX = 250;
          var posY = 273;
          if (i > 5) {
            posX = 950;
            posY = -207;
          }
          var yr3_audio_container1: any = new createjs.Container();
          let audiobutton1: any = new createjs.Bitmap(audiobutton_1);
          audiobutton1.setTransform(posX, posY + (i * 80));
          audiobutton1.cursor = "pointer";
          yr3_audio_container1.addChild(audiobutton1);
          yr3_audio_container1.id = count;
          yr3_audio_container1.click = 0;
          yr3_audio_container1.name = "removeimage";
          yr3_audio_container1.on("click", checkaudio);
          stage.addChild(yr3_audio_container1);
          count = count + 1;
        }
      }

      var textBoxes = [];
      var activeBox = null;
      var answercorrect = 0;
      var combineshuffletextarray = '';

      function checkaudio(event) {
        $("#temp_textbox").val("");
        $("#temp_textbox").focus();
        event.currentTarget.click = event.currentTarget.click + 1;
        if (event.currentTarget.click > 1) {
          sounds[event.currentTarget.id].play();
          resethightlighter();
          startingpos(event);
        } else {
          resethightlighter();
          sounds[event.currentTarget.id].play();
          let QstnTxtArr;
          let Qstn = createQstnArr(yr3_chaptertextarray[event.currentTarget.id], 872, 690, 90, 0);
          QstnTxtArr = Qstn[event.currentTarget.id];
          combineshuffletextarray += yr3_chaptertextarray[event.currentTarget.id];
          let col;
          let Xpos = 360;
          for (col = 0; col < yr3_chaptertextarray[event.currentTarget.id].length; col++) {

            var yaxis_box = 280;

            if (event.currentTarget.id > 5) {
              Xpos = 1058;
              yaxis_box = -200;
            } else {
              Xpos = 360;
              yaxis_box = 280;
            }

            var xaxis_box = Xpos + (col * 40);

            let textBoxtemp: any = new createjs.Container();

            let textBox_rectangle = new createjs.Shape();
            textBox_rectangle.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke('#01C1D6').drawRoundRect(0, 0, 40, 40, 0);
            textBox_rectangle.setTransform(xaxis_box, yaxis_box + (event.currentTarget.id * 80));

            let textBox_highlighter = new createjs.Shape();
            textBox_highlighter.graphics.setStrokeStyle(2).f("#FDF5CE").beginStroke('#01C1D6').drawRoundRect(0, 0, 40, 40, 0);
            textBox_highlighter.setTransform(xaxis_box, yaxis_box + (event.currentTarget.id * 80));
            textBox_highlighter.visible = (col == 0) ? true : false;

            var textBoxText = new createjs.Text("", "50px MajemaSkol_Exercise_bold", "#808080");
            textBoxText.textAlign = 'center';
            textBoxText.x = xaxis_box + 20;
            var sizeof = 27;
            textBoxText.y = yaxis_box + sizeof + (event.currentTarget.id * 80);
            textBoxText.textBaseline = "alphabetic";
            textBoxtemp.addChild(textBox_rectangle, textBox_highlighter, textBoxText);
            textBoxtemp.name = "removeimage";
            textBoxtemp.textBoxText = textBoxText;


            textBoxtemp.on('click', function (evt) {
              document.getElementById("temp_textbox").style.display = "block";
              $("#temp_textbox").val("");
              $("#temp_textbox").focus();
              if (answercorrect == 0) {
                var indexc = 0;
                for (var i = 0; i < textBoxes.length; i++) {
                  textBoxes[i].children[1].visible = false;
                  textBoxes[i].isClicked = false;
                  if (evt.currentTarget == textBoxes[i]) {
                    indexc = i;
                  }
                }

                evt.currentTarget.children[1].visible = true;
                textBoxes[indexc].isClicked = true;
                evt.currentTarget.isClicked = true;

              }
            });

            textBoxes.push(textBoxtemp);


            if (col == 0) {
              textBoxtemp.isClicked = true;
            }

            stage.addChild(textBoxtemp);
          }
        }
      }

      function resethightlighter() {
        for (var j = 0; j < textBoxes.length; j++) {
          textBoxes[j].isClicked = false;
          textBoxes[j].children[1].visible = false;
        }
      }

      function startingpos(event) {
        var n = combineshuffletextarray.indexOf(yr3_chaptertextarray[event.currentTarget.id]);
        textBoxes[n].isClicked = true;
        textBoxes[n].children[1].visible = true;
      }

      //pc/ipad listner
      if (!android_dev) {
        document.addEventListener("keypress", function (evt: any) {
          keyPressCalback(evt);
        });
        document.addEventListener('keydown', function (evt) {
          clickBackspace(evt);
        });
      }
      //android listner
      if (android_dev) {
        exercise = 1;
      }
      function keyPressCalback(evt) {
       if (answercorrect == 0 && textBoxes.length > 0) {
          evt = evt || window.event;
          var charCode = evt.keyCode || evt.which;
          var charStr = String.fromCharCode(charCode);
          var intStrval = validatefunc(charStr, "4");
          var splchrval = validatefunc(charStr, "6");
          if (intStrval || splchrval) {
            return 0;
          }
          if (textBoxes[0].children[1].visible == true) {
            textBoxes[0].isClicked = true;
          }
          for (var i = 0; i < textBoxes.length; i++) {
            if (textBoxes[i].isClicked == true) {
              activeBox = textBoxes[i];
              activeBox.index = i;
              break;
            }
          }
          var allowedChars = ['+', '-', '='];

          if (!(combineshuffletextarray[activeBox.index].toUpperCase() == charStr) && !(combineshuffletextarray[activeBox.index].toLowerCase() == charStr)) {
            activeBox.children[2].color = "red";
            activeBox.isClicked = false;
            var nxtIndex = textBoxes.indexOf(activeBox) + 1;
            if (nxtIndex < textBoxes.length) {
              for (var i = 0; i < textBoxes.length; i++) {
                textBoxes[i].children[1].visible = false;
              }
              textBoxes[nxtIndex].isClicked = true;
              textBoxes[nxtIndex].children[1].visible = true;
            }
          }
          else {
            activeBox.children[2].color = "#808080";
            activeBox.isClicked = false;
            var nxtIndex = textBoxes.indexOf(activeBox) + 1;
            if (nxtIndex < textBoxes.length) {
              for (var i = 0; i < textBoxes.length; i++) {
                textBoxes[i].children[1].visible = false;
              }
              textBoxes[nxtIndex].isClicked = true;
              textBoxes[nxtIndex].children[1].visible = true;
            }
          }

          if (activeBox != null && allowedChars.indexOf(charStr) > -10) {
            activeBox.textBoxText = (charStr == '-') ? '–' : charStr;
            activeBox.children[2].text = (charStr == '-') ? '–' : charStr;

            if (combineshuffletextarray.length == textBoxes.length) {
              var k = 0;
              for (var j = 0; j < textBoxes.length; j++) {
                if ((combineshuffletextarray[j].toUpperCase() == textBoxes[j].children[2].text) || (combineshuffletextarray[j].toLowerCase() == textBoxes[j].children[2].text)) {
                  k++;
                }
              }
            }

            if (k > 0 && k == 89) {
              for (var i = 0; i < 90; i++) {
              if (textBoxes[i] && textBoxes[i] != "") {
                  textBoxes[i].children[1].visible = false;
                  textBoxes[i].isClicked = false;
                  activeBox = null;
                  cheersound[audiocount1].play();
                  yr3_next_button.visible = true;
                }
              }
              answercorrect = 1;
              stage.clear();

            }
          }

        }
      }


     function clickBackspace(evt) {
       if (answercorrect == 0 && textBoxes.length > 0) {
          var isBackspace = (evt.keyCode == 8) ? true : false;
          var isDelete = (evt.keyCode == 46) ? true : false;
          var isTab = (evt.keyCode == 9) ? true : false;
          var isLeftarrow = (evt.keyCode == 37) ? true : false;
          var isRightarrow = (evt.keyCode == 39) ? true : false;

          for (var i = 0; i < textBoxes.length; i++) {
            if (textBoxes[i].isClicked == true) {
              activeBox = textBoxes[i];
              break;
            }
          }
          if (isLeftarrow == true) {
            evt.preventDefault();
            activeBox.isClicked = false;
            var prevIndex = textBoxes.indexOf(activeBox) - 1;
            prevIndex = (prevIndex < 0) ? (textBoxes.length - 1) : prevIndex;
            for (var i = 0; i < textBoxes.length; i++) {
              textBoxes[i].children[1].visible = false;
            }
            textBoxes[prevIndex].children[1].visible = true;
            textBoxes[prevIndex].isClicked = true;

            return 0;
          }
          if (isTab == true || isRightarrow == true) {
            evt.preventDefault();
            activeBox.isClicked = false;
            var nxtIndex = textBoxes.indexOf(activeBox) + 1;
            nxtIndex = (nxtIndex == textBoxes.length) ? 0 : nxtIndex;
            for (var i = 0; i < textBoxes.length; i++) {
              textBoxes[i].children[1].visible = false;
            }
            textBoxes[nxtIndex].children[1].visible = true;
            textBoxes[nxtIndex].isClicked = true;

            return 0;
          }
          if (isBackspace == true) {
            if (activeBox.children[2].text && activeBox.children[2].text != "") {
              activeBox.children[2].text = "";
              activeBox.children[1].visible = true;
            }
            else {
              if (activeBox != null) {
                var prevIndex = textBoxes.indexOf(activeBox) - 1;
                if (prevIndex >= 0) {
                  activeBox.isClicked = false;
                  for (var i = 0; i < textBoxes.length; i++) {
                    textBoxes[i].children[1].visible = false;
                  }
                  textBoxes[prevIndex].children[1].visible = true;
                  textBoxes[prevIndex].isClicked = true;
                }
              }
            }

            return 0;
          }
          if (isDelete == true) {
            if (activeBox != null) {
              var nextIndex = textBoxes.indexOf(activeBox);
              if (nextIndex < textBoxes.length) {
                textBoxes[nextIndex].children[2].text = "";
                activeBox.isClicked = false;
                for (var i = 0; i < textBoxes.length; i++) {
                  textBoxes[i].children[1].visible = false;
                }
                textBoxes[nextIndex].children[1].visible = true;
                textBoxes[nextIndex].isClicked = true;
              }
            }

            return 0;
          }
        }
      }

      stage.addChild(yr3_heading1, yr3_heading1_ipad);
      yr3_ex_stava.keyPressCalback = keyPressCalback;
      yr3_ex_stava.clickBackspace = clickBackspace;
    }
    yr3_ex_stava(bloburl, 0);

    function shuffle(obj1, obj2) {
      var index = obj1.length;
      var rnd, tmp1, tmp2;

      while (index) {
        rnd = Math.floor(Math.random() * index);
        index -= 1;
        tmp1 = obj1[index];
        tmp2 = obj2[index];
        obj1[index] = obj1[rnd];
        obj2[index] = obj2[rnd];
        obj1[rnd] = tmp1;
        obj2[rnd] = tmp2;
      }
    }
    shuffle(cheersound, cheersound);

    var yr3_ex_skriva: any = function (bloburl, audiocountaudio) {

      for (var s = 0; s < stage.children.length; s++) {
        if (stage.children[s].name == "removeimage" || stage.children[s].name == "removeimage1") {
          stage.removeChild(stage.children[s]);
          s = s - 1;
        }
      }

      var yr3_kontrolleraimg = new createjs.Bitmap(newexe);
      yr3_kontrolleraimg.setTransform(1550, 742);
      yr3_kontrolleraimg.cursor = "pointer";
      yr3_kontrolleraimg.visible = true;
      yr3_kontrolleraimg.name = "removeimage";

      yr3_next_button.visible = false;

      shuffle(cheersound, cheersound);

      yr3_opt_circle1.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle1.outColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();
      yr3_opt_circle2.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle2.overColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();

      var yr3_heading2 = new createjs.Text("Stava", "bold 60px Dk-mariken", "#FF0000");
      if (isIOS) {

        var yr3_heading2 = new createjs.Text("Stava", "60px Dk-mariken", "#FF0000");
        yr3_heading2.outline = 2;

        var yr3_heading2_ipad = new createjs.Text("Stava", "60px Dk-mariken", "#FF0000");
        yr3_heading2_ipad.textAlign = "center";
        yr3_heading2_ipad.name = "removeimage1";
        yr3_heading2_ipad.setTransform(890, 80);
      }
      yr3_heading2.textAlign = "center";
      yr3_heading2.name = "removeimage1";
      yr3_heading2.setTransform(890, 80);

      var yr3_chaptertextarray1 = ["Stjärna        ", "Skjuta         ", "Stjäla         ", "Skjul          ", "Blomstjälk     ", "Skjorta        ", "Skolskjuts     ", "Stjärt         ", "Stjälk         ", "Vedskjul       ",
        "Skjutsa        ", "Rockstjärna    "];

      var yr3_soundsArr1 = [bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio1.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio2.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio3.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio4.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio5.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio6.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio7.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio8.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio9.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio10.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio11.mp3",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/audio/chapter6/audio12.mp3"
      ];

      shuffle(yr3_chaptertextarray1, yr3_soundsArr1);

      for (var i = 0; i < 6; i++) {
        for (var j = 0; j < 2; j++) {
          var yr3_linecontainer1 = new createjs.Container();
          let yr3_ansline = new createjs.Shape();
          yr3_ansline.graphics.setStrokeStyle(2).beginStroke('#01C1D6').moveTo(0, 0).lineTo(400, 0);
          yr3_ansline.setTransform(360 + (j * 700), 330 + (i * 80));
          yr3_linecontainer1.addChild(yr3_ansline);
          yr3_linecontainer1.name = "removeimage1";
          stage.addChild(yr3_linecontainer1);
        }
      }

      var sounds1 = [];

      for (var t = 0; t < yr3_soundsArr1.length; t++) {
        var sound11: any = new Audio();
        sound11.src = yr3_soundsArr1[t];
        sound11.crossOrigin = "Anonymous";
        sound11.name = "removeimage1";
        sounds1.push(sound11);
      }

      var audiobutton_11 = new Image();
      audiobutton_11.crossOrigin = "Anonymous";
      audiobutton_11.name = "removeimage1";
      audiobutton_11.src = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/stava/stavaimages/play.png";

      var count = 0;
      for (var i = 0; i < 12; i++) {
        for (var j = 0; j < 1; j++) {
          var posX = 250;
          var posY = 273;
          if (i > 5) {
            posX = 950;
            posY = -207;
          }
          var yr3_audio_container2: any = new createjs.Container();
          let audiobutton11: any = new createjs.Bitmap(audiobutton_11);
          audiobutton11.setTransform(posX, posY + (i * 80));
          audiobutton11.cursor = "pointer";
          yr3_audio_container2.addChild(audiobutton11);
          yr3_audio_container2.id = count;
          yr3_audio_container2.click = 0;
          yr3_audio_container2.name = "removeimage1";
          yr3_audio_container2.on("click", checkaudio1);
          stage.addChild(yr3_audio_container2);
          count = count + 1;
        }
      }


      let QstnTxtArr;
      var textBoxes1 = [];
      var activeBox1 = null;
      var answercorrect = 0;
      var combineshuffletextarray1 = '';


      function checkaudio1(event) {
        $("#temp_textbox").val("");
        $("#temp_textbox").focus();
        event.currentTarget.click = event.currentTarget.click + 1;
        if (event.currentTarget.click > 1) {
          sounds1[event.currentTarget.id].play();
          resethightlighter1();
          startingpos1(event);
        } else {
          resethightlighter1();
          let Qstn = createQstnArr(yr3_chaptertextarray1[event.currentTarget.id], 872, 690, 90, 0);
          QstnTxtArr = Qstn[0];
          combineshuffletextarray1 += yr3_chaptertextarray1[event.currentTarget.id];
          let col;
          let Xpos = 360;

          for (col = 0; col < 15; col++) {

            var yaxis_box = 280;

            if (event.currentTarget.id > 5) {
              Xpos = 1058;
              yaxis_box = -200;
            } else {
              Xpos = 360;
              yaxis_box = 280;
            }

            var xaxis_box = Xpos + (col * 27);

            let textBoxtemp: any = new createjs.Container();

            let textBox_rectangle = new createjs.Shape();
            textBox_rectangle.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke('#FFFFFF').drawRoundRect(0, 0, 25, 40, 0);
            textBox_rectangle.setTransform(xaxis_box, yaxis_box + (event.currentTarget.id * 80));

            let textBox_line: any = new createjs.Shape();
            textBox_line.overColor = "#FFFFFF";
            textBox_line.outColor = "#FF0000";
            textBox_line.graphics.setStrokeStyle(2).beginStroke(textBox_line.overColor).moveTo(0, 0).lineTo(25, 0);
            textBox_line.setTransform(Xpos + (col * 27), yaxis_box + 45 + (event.currentTarget.id * 80));

            let textBox_highlighter = new createjs.Shape();
            textBox_highlighter.graphics.setStrokeStyle(2).f("#FDF5CE").beginStroke('#FFFFFF').drawRoundRect(0, 0, 25, 40, 0);
            textBox_highlighter.setTransform(xaxis_box, yaxis_box + (event.currentTarget.id * 80));
            textBox_highlighter.visible = (col == 0) ? true : false;

            var textBoxText = new createjs.Text(" ", "50px MajemaSkol_Exercise_bold", "#808080");
            textBoxText.textAlign = 'center';
            textBoxText.x = xaxis_box + 12.5;
            var sizeof = 27;
            textBoxText.y = yaxis_box + sizeof + (event.currentTarget.id * 80);
            textBoxText.textBaseline = "alphabetic";
            textBoxtemp.addChild(textBox_rectangle, textBox_highlighter, textBoxText, textBox_line);
            textBoxtemp.name = "removeimage1";
            textBoxtemp.textBoxText = textBoxText;


            textBoxtemp.on('click', function (evt) {
              document.getElementById("temp_textbox").style.display = "block";
              $("#temp_textbox").val("");
              $("#temp_textbox").focus();
              if (answercorrect == 0) {
                var indexc = 0;
                for (var i = 0; i < textBoxes1.length; i++) {
                  textBoxes1[i].children[1].visible = false;
                  textBoxes1[i].isClicked = false;
                  if (evt.currentTarget == textBoxes1[i]) {
                    indexc = i;
                  }
                }

                evt.currentTarget.children[1].visible = true;
                textBoxes1[indexc].isClicked = true;
                evt.currentTarget.isClicked = true;

              }
            });

            textBoxes1.push(textBoxtemp);


            if (col == 0) {
              textBoxtemp.isClicked = true;
            }

            stage.addChild(textBoxtemp);
          }
          sounds1[event.currentTarget.id].play();
        }
      }

      function resethightlighter1() {
        for (var j = 0; j < textBoxes1.length; j++) {
          textBoxes1[j].isClicked = false;
          textBoxes1[j].children[1].visible = false;
        }
      }
      function startingpos1(event) {
        var n = combineshuffletextarray1.indexOf(yr3_chaptertextarray1[event.currentTarget.id]);
        textBoxes1[n].isClicked = true;
        textBoxes1[n].children[1].visible = true;
      }

      //pc/ipad listner
      if (!android_dev) {
        document.addEventListener("keypress", function (evt: any) {
          keyPressCalback2(evt);
        });
        document.addEventListener('keydown', function (evt) {
          clickBackspace2(evt);
        });
      }
      //android listner
      if (android_dev) {
        exercise = 2;
      }
      function keyPressCalback2(evt) {

       if (answercorrect == 0 && textBoxes1.length > 0) {
          evt = evt || window.event;
          var charCode = evt.keyCode || evt.which;
          var charStr = String.fromCharCode(charCode);
          var intStrval = validatefunc(charStr, "4");
          var splchrval = validatefunc(charStr, "6");
          if (intStrval || splchrval) {
            return 0;
          }
          if (textBoxes1[0].children[1].visible == true) {
            textBoxes1[0].isClicked = true;
          }
          for (var i = 0; i < textBoxes1.length; i++) {
            if (textBoxes1[i].isClicked == true) {
              activeBox1 = textBoxes1[i];
              activeBox1.index = i;
              break;
            }
          }
          var allowedChars = ['+', '-', '='];



          if (!(QstnTxtArr[activeBox1.index] == charStr)) {
            activeBox1.children[2].color = "#808080";
          }
          else {
            activeBox1.children[2].color = "#808080";
          }



          if (activeBox1 != null && allowedChars.indexOf(charStr) > -10) {
            activeBox1.textBoxText = (charStr == '-') ? '–' : charStr;
            activeBox1.children[2].text = (charStr == '-') ? '–' : charStr;

            if (QstnTxtArr.length == textBoxes1.length) {
              var k = 0;
              for (var j = 0; j < textBoxes1.length; j++) {
                if (QstnTxtArr[j] == textBoxes1[j].children[2].text) {
                  k++;
                }
              }
            }
            if (k > 0 && k == textBoxes1.length) {

              activeBox1.isClicked = false;
              var nxtIndex = textBoxes1.indexOf(activeBox1) + 1;
              if (nxtIndex < textBoxes1.length) {
                for (var i = 0; i < textBoxes1.length; i++) {
                  textBoxes1[i].children[1].visible = false;
                }
                textBoxes1[nxtIndex].isClicked = true;
                textBoxes1[nxtIndex].children[1].visible = true;



              }
            } else {
              activeBox1.isClicked = false;
              var nxtIndex = textBoxes1.indexOf(activeBox1) + 1;
              if (nxtIndex < textBoxes1.length) {
                for (var i = 0; i < textBoxes1.length; i++) {
                  textBoxes1[i].children[1].visible = false;
                }
                textBoxes1[nxtIndex].isClicked = true;
                textBoxes1[nxtIndex].children[1].visible = true;
              }
            }


          }


        }
      }

      yr3_kontrolleraimg.addEventListener('click', function () {


        //to check the individual text - color change

        for (var t = 0; t < combineshuffletextarray1.length; t++) {
          if ((textBoxes1[t].children[2].text != "")) {
            if ((textBoxes1[t].children[2].text != combineshuffletextarray1[t].toLowerCase()) && (textBoxes1[t].children[2].text != combineshuffletextarray1[t].toUpperCase())) {
              textBoxes1[t].children[2].color = "red";
            } else {
              textBoxes1[t].children[2].color = "#808080";
            }
          }
        }

        //to check the individual text - play cheerssound

        for (var t2 = 0; t2 < combineshuffletextarray1.length; t2++) {
          if ((textBoxes1[t2].children[2].text == combineshuffletextarray1[t2].toLowerCase() && textBoxes1[t2].children[2].color == "#808080") || (textBoxes1[t2].children[2].text == combineshuffletextarray1[t2].toUpperCase() && textBoxes1[t2].children[2].color == "#808080")) {
            if (t2 == combineshuffletextarray1.length - 1) {
              cheersound[audiocountaudio].play();
              audiocountaudio = audiocountaudio + 1;
            }
          }
          else {
            break;
          }
        }

        //to check the individual text - to underline the empty textboxes

        for (var t3 = 0; t3 < combineshuffletextarray1.length; t3++) {
          if ((textBoxes1[t3].children[2].text == " ")) {
            if (textBoxes1[t3].children[2].text == combineshuffletextarray1[t3]) {
              textBoxes1[t3].children[3].graphics.clear().setStrokeStyle(2).beginStroke("#FFFFFF").moveTo(0, 0).lineTo(25, 0);
            }
            else {
              textBoxes1[t3].children[3].graphics.clear().setStrokeStyle(2).beginStroke("#FF0000").moveTo(0, 0).lineTo(25, 0);
            }
          }
          else {
            textBoxes1[t3].children[3].graphics.clear().setStrokeStyle(2).beginStroke("#FFFFFF").moveTo(0, 0).lineTo(25, 0);
          }
        }

        //to check the all text - move to next exercise

        for (var t1 = 0; t1 < 180; t1++) {
          if (textBoxes1.length > 0) {

          if (textBoxes1[0].children[2].color == "#808080" && textBoxes1[1].children[2].color == "#808080"
            && textBoxes1[2].children[2].color == "#808080" && textBoxes1[3].children[2].color == "#808080"
            && textBoxes1[4].children[2].color == "#808080" && textBoxes1[5].children[2].color == "#808080"
            && textBoxes1[6].children[2].color == "#808080" && textBoxes1[7].children[2].color == "#808080"
            && textBoxes1[8].children[2].color == "#808080" && textBoxes1[9].children[2].color == "#808080"
            && textBoxes1[10].children[2].color == "#808080" && textBoxes1[11].children[2].color == "#808080"
            && textBoxes1[12].children[2].color == "#808080" && textBoxes1[13].children[2].color == "#808080"
            && textBoxes1[14].children[2].color == "#808080" && textBoxes1[15].children[2].color == "#808080"
            && textBoxes1[16].children[2].color == "#808080" && textBoxes1[17].children[2].color == "#808080"
            && textBoxes1[18].children[2].color == "#808080" && textBoxes1[19].children[2].color == "#808080"
            && textBoxes1[20].children[2].color == "#808080" && textBoxes1[21].children[2].color == "#808080"
            && textBoxes1[22].children[2].color == "#808080" && textBoxes1[23].children[2].color == "#808080"
            && textBoxes1[24].children[2].color == "#808080" && textBoxes1[25].children[2].color == "#808080"
            && textBoxes1[26].children[2].color == "#808080" && textBoxes1[27].children[2].color == "#808080"
            && textBoxes1[28].children[2].color == "#808080" && textBoxes1[29].children[2].color == "#808080"
            && textBoxes1[30].children[2].color == "#808080" && textBoxes1[31].children[2].color == "#808080"
            && textBoxes1[32].children[2].color == "#808080" && textBoxes1[33].children[2].color == "#808080"
            && textBoxes1[34].children[2].color == "#808080" && textBoxes1[35].children[2].color == "#808080"
            && textBoxes1[36].children[2].color == "#808080" && textBoxes1[37].children[2].color == "#808080"
            && textBoxes1[38].children[2].color == "#808080" && textBoxes1[39].children[2].color == "#808080"
            && textBoxes1[40].children[2].color == "#808080" && textBoxes1[41].children[2].color == "#808080"
            && textBoxes1[42].children[2].color == "#808080" && textBoxes1[43].children[2].color == "#808080"
            && textBoxes1[44].children[2].color == "#808080" && textBoxes1[45].children[2].color == "#808080"
            && textBoxes1[46].children[2].color == "#808080" && textBoxes1[47].children[2].color == "#808080"
            && textBoxes1[48].children[2].color == "#808080" && textBoxes1[49].children[2].color == "#808080"
            && textBoxes1[50].children[2].color == "#808080" && textBoxes1[51].children[2].color == "#808080"


            && textBoxes1[52].children[2].color == "#808080" && textBoxes1[53].children[2].color == "#808080"
            && textBoxes1[54].children[2].color == "#808080" && textBoxes1[55].children[2].color == "#808080"
            && textBoxes1[56].children[2].color == "#808080" && textBoxes1[57].children[2].color == "#808080"
            && textBoxes1[58].children[2].color == "#808080" && textBoxes1[59].children[2].color == "#808080"
            && textBoxes1[60].children[2].color == "#808080" && textBoxes1[61].children[2].color == "#808080"
            && textBoxes1[62].children[2].color == "#808080" && textBoxes1[63].children[2].color == "#808080"
            && textBoxes1[64].children[2].color == "#808080" && textBoxes1[65].children[2].color == "#808080"
            && textBoxes1[66].children[2].color == "#808080" && textBoxes1[67].children[2].color == "#808080"
            && textBoxes1[68].children[2].color == "#808080" && textBoxes1[69].children[2].color == "#808080"
            && textBoxes1[70].children[2].color == "#808080" && textBoxes1[71].children[2].color == "#808080"
            && textBoxes1[72].children[2].color == "#808080" && textBoxes1[73].children[2].color == "#808080"
            && textBoxes1[74].children[2].color == "#808080" && textBoxes1[75].children[2].color == "#808080"
            && textBoxes1[76].children[2].color == "#808080" && textBoxes1[77].children[2].color == "#808080"
            && textBoxes1[78].children[2].color == "#808080" && textBoxes1[79].children[2].color == "#808080"
            && textBoxes1[80].children[2].color == "#808080" && textBoxes1[81].children[2].color == "#808080"
            && textBoxes1[82].children[2].color == "#808080" && textBoxes1[83].children[2].color == "#808080"
            && textBoxes1[84].children[2].color == "#808080" && textBoxes1[85].children[2].color == "#808080"
            && textBoxes1[86].children[2].color == "#808080" && textBoxes1[87].children[2].color == "#808080"
            && textBoxes1[88].children[2].color == "#808080" && textBoxes1[89].children[2].color == "#808080"
            && textBoxes1[90].children[2].color == "#808080" && textBoxes1[91].children[2].color == "#808080"
            && textBoxes1[92].children[2].color == "#808080" && textBoxes1[93].children[2].color == "#808080"
            && textBoxes1[94].children[2].color == "#808080" && textBoxes1[95].children[2].color == "#808080"
            && textBoxes1[96].children[2].color == "#808080" && textBoxes1[97].children[2].color == "#808080"
            && textBoxes1[98].children[2].color == "#808080" && textBoxes1[99].children[2].color == "#808080"


            && textBoxes1[100].children[2].color == "#808080" && textBoxes1[101].children[2].color == "#808080"
            && textBoxes1[102].children[2].color == "#808080" && textBoxes1[103].children[2].color == "#808080"
            && textBoxes1[104].children[2].color == "#808080" && textBoxes1[105].children[2].color == "#808080"
            && textBoxes1[106].children[2].color == "#808080" && textBoxes1[107].children[2].color == "#808080"
            && textBoxes1[108].children[2].color == "#808080" && textBoxes1[109].children[2].color == "#808080"
            && textBoxes1[110].children[2].color == "#808080" && textBoxes1[111].children[2].color == "#808080"
            && textBoxes1[112].children[2].color == "#808080" && textBoxes1[113].children[2].color == "#808080"
            && textBoxes1[114].children[2].color == "#808080" && textBoxes1[115].children[2].color == "#808080"
            && textBoxes1[116].children[2].color == "#808080" && textBoxes1[117].children[2].color == "#808080"
            && textBoxes1[118].children[2].color == "#808080" && textBoxes1[119].children[2].color == "#808080"
            && textBoxes1[120].children[2].color == "#808080" && textBoxes1[121].children[2].color == "#808080"
            && textBoxes1[122].children[2].color == "#808080" && textBoxes1[123].children[2].color == "#808080"
            && textBoxes1[124].children[2].color == "#808080" && textBoxes1[125].children[2].color == "#808080"
            && textBoxes1[126].children[2].color == "#808080" && textBoxes1[127].children[2].color == "#808080"
            && textBoxes1[128].children[2].color == "#808080" && textBoxes1[129].children[2].color == "#808080"
            && textBoxes1[130].children[2].color == "#808080" && textBoxes1[131].children[2].color == "#808080"
            && textBoxes1[132].children[2].color == "#808080" && textBoxes1[133].children[2].color == "#808080"
            && textBoxes1[134].children[2].color == "#808080" && textBoxes1[135].children[2].color == "#808080"
            && textBoxes1[136].children[2].color == "#808080" && textBoxes1[137].children[2].color == "#808080"
            && textBoxes1[138].children[2].color == "#808080" && textBoxes1[139].children[2].color == "#808080"
            && textBoxes1[140].children[2].color == "#808080" && textBoxes1[141].children[2].color == "#808080"
            && textBoxes1[142].children[2].color == "#808080" && textBoxes1[143].children[2].color == "#808080"
            && textBoxes1[144].children[2].color == "#808080" && textBoxes1[145].children[2].color == "#808080"
            && textBoxes1[146].children[2].color == "#808080" && textBoxes1[147].children[2].color == "#808080"


            && textBoxes1[148].children[2].color == "#808080" && textBoxes1[149].children[2].color == "#808080"
            && textBoxes1[150].children[2].color == "#808080" && textBoxes1[151].children[2].color == "#808080"
            && textBoxes1[152].children[2].color == "#808080" && textBoxes1[153].children[2].color == "#808080"
            && textBoxes1[154].children[2].color == "#808080" && textBoxes1[155].children[2].color == "#808080"
            && textBoxes1[156].children[2].color == "#808080" && textBoxes1[157].children[2].color == "#808080"
            && textBoxes1[158].children[2].color == "#808080" && textBoxes1[159].children[2].color == "#808080"
            && textBoxes1[160].children[2].color == "#808080" && textBoxes1[161].children[2].color == "#808080"
            && textBoxes1[162].children[2].color == "#808080" && textBoxes1[163].children[2].color == "#808080"
            && textBoxes1[164].children[2].color == "#808080" && textBoxes1[165].children[2].color == "#808080"
            && textBoxes1[166].children[2].color == "#808080" && textBoxes1[167].children[2].color == "#808080"
            && textBoxes1[168].children[2].color == "#808080" && textBoxes1[169].children[2].color == "#808080"
            && textBoxes1[170].children[2].color == "#808080" && textBoxes1[171].children[2].color == "#808080"
            && textBoxes1[172].children[2].color == "#808080" && textBoxes1[173].children[2].color == "#808080"
            && textBoxes1[174].children[2].color == "#808080" && textBoxes1[175].children[2].color == "#808080"
            && textBoxes1[176].children[2].color == "#808080" && textBoxes1[177].children[2].color == "#808080"
            && textBoxes1[178].children[2].color == "#808080" && textBoxes1[179].children[2].color == "#808080"

          ) {

            yr3_kontrolleraimg.visible = false;
            yr3_fortsattimg.visible = true;
          }
          }
        }

      });

      function clickBackspace2(evt) {
       if (answercorrect == 0 && textBoxes1.length > 0) {
          var isBackspace = (evt.keyCode == 8) ? true : false;
          var isDelete = (evt.keyCode == 46) ? true : false;
          var isTab = (evt.keyCode == 9) ? true : false;
          var isLeftarrow = (evt.keyCode == 37) ? true : false;
          var isRightarrow = (evt.keyCode == 39) ? true : false;

          for (var i = 0; i < textBoxes1.length; i++) {
            if (textBoxes1[i].isClicked == true) {
              activeBox1 = textBoxes1[i];
              break;
            }
          }
          if (isLeftarrow == true) {
            evt.preventDefault();
            activeBox1.isClicked = false;
            var prevIndex = textBoxes1.indexOf(activeBox1) - 1;
            prevIndex = (prevIndex < 0) ? (textBoxes1.length - 1) : prevIndex;
            for (var i = 0; i < textBoxes1.length; i++) {
              textBoxes1[i].children[1].visible = false;
            }
            textBoxes1[prevIndex].children[1].visible = true;
            textBoxes1[prevIndex].isClicked = true;

            return 0;
          }
          if (isTab == true || isRightarrow == true) {
            evt.preventDefault();
            activeBox1.isClicked = false;
            var nxtIndex = textBoxes1.indexOf(activeBox1) + 1;
            nxtIndex = (nxtIndex == textBoxes1.length) ? 0 : nxtIndex;
            for (var i = 0; i < textBoxes1.length; i++) {
              textBoxes1[i].children[1].visible = false;
            }
            textBoxes1[nxtIndex].children[1].visible = true;
            textBoxes1[nxtIndex].isClicked = true;

            return 0;
          }
          if (isBackspace == true) {
            if (activeBox1.children[2].text && activeBox1.children[2].text != " ") {
              activeBox1.children[2].text = " ";
              activeBox1.children[2].color = "#808080";
              activeBox1.children[1].visible = true;
            }
            else {
              if (activeBox1 != null) {
                var prevIndex = textBoxes1.indexOf(activeBox1) - 1;
                if (prevIndex >= 0) {
                  activeBox1.isClicked = false;
                  for (var i = 0; i < textBoxes1.length; i++) {
                    textBoxes1[i].children[1].visible = false;
                  }
                  textBoxes1[prevIndex].children[1].visible = true;
                  textBoxes1[prevIndex].isClicked = true;
                }
              }
            }

            return 0;
          }
          if (isDelete == true) {
            if (activeBox1 != null) {
              var nextIndex = textBoxes1.indexOf(activeBox1);
              if (nextIndex < textBoxes1.length) {
                textBoxes1[nextIndex].children[2].text = " ";
                activeBox1.isClicked = false;
                for (var i = 0; i < textBoxes1.length; i++) {
                  textBoxes1[i].children[1].visible = false;
                }
                textBoxes1[nextIndex].children[1].visible = true;
                textBoxes1[nextIndex].isClicked = true;
              }
            }

            return 0;
          }
        }
      }

      stage.addChild(yr3_heading2, yr3_heading2_ipad, yr3_kontrolleraimg);
      yr3_ex_skriva.keyPressCalback2 = keyPressCalback2;
      yr3_ex_skriva.clickBackspace2 = clickBackspace2;
    }
    function myeventfunc(evt) {
      var inputValue = this.value;
      var lastChar = inputValue.substr(inputValue.length - 1);
      $('#temp_textbox').val(lastChar);
      if (evt.key && evt.key != "Unidentified") {
        
        if (evt.key == "Delete" || evt.key == "Backspace") {
          $('#temp_textbox').val("");

          if (exercise == 1) {
            yr3_ex_stava.clickBackspace(evt);
          }
          else {
            yr3_ex_skriva.clickBackspace2(evt);
          }
        }

      }
      else {
        var newevt: any = {};
        if (lastChar && lastChar != "") {
          newevt.which = lastChar.charCodeAt(0);
          if (exercise == 1) {
            yr3_ex_stava.keyPressCalback(newevt);
          }
          else {
            yr3_ex_skriva.keyPressCalback2(newevt);
          }
          
        }
        else {
          newevt.keyCode = 8;
          if (exercise == 1) {
            yr3_ex_stava.clickBackspace(newevt);
          }
          else {
            yr3_ex_skriva.clickBackspace2(newevt);
          }
          
        }
      }
    }

    if (android_dev) {
      this.eventHandler = myeventfunc;
      var myTxt = document.getElementById("temp_textbox");
      myTxt.addEventListener("keyup", this.eventHandler, true);
    }
    function validatefunc(word, type) {
      if (word != "" && type != "") {
        var reqularexp = [];
        reqularexp[0] = /^\d*$/;
        reqularexp[1] = /^[a-zA-Z ]*$/;
        reqularexp[2] = /^[a-z\d\-_\s]+$/i;

        reqularexp[3] = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        reqularexp[4] = /^[\d\-+\s]+$/i;

        reqularexp[5] = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

        reqularexp[6] = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;
        var regexppattern = reqularexp[type];
        if (regexppattern.test(word)) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    }

    function createQstnArr(Imgname, sxpos, sypos, xint, yint) {
      let QstnTxtArr = Imgname.split('');
      let QstnArray: string[] = [];
      let QstnArray_X: number[] = [];
      let QstnArray_Y: number[] = [];

      let Qtalength = QstnTxtArr.length;
      sxpos = sxpos - (40 * Qtalength);

      for (let i = 0; i < QstnTxtArr.length; i++) {

        if (i !== 0) {
          sxpos = sxpos + xint;
          sypos = sypos + yint;
        }

        QstnArray[i] = QstnTxtArr[i];
        QstnArray_X[i] = sxpos;
        QstnArray_Y[i] = sypos;
      }

      return [
        QstnArray,
        QstnArray_X,
        QstnArray_Y
      ];

    }

    stage.addChild(yr3_tagimage1, yr3_bitmap, yr3_option_container, yr3_opt_circle1, yr3_opt_circle2, yr3_chapterimg, yr3_fortsattimg, yr3_next_button);
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');

  }
  ngOnDestroy() {
    document.removeEventListener("keyup", this.eventHandler, true);
  }
}


